import { render } from "./MasterPayments.vue?vue&type=template&id=6a645ddd&scoped=true"
import script from "./MasterPayments.vue?vue&type=script&lang=js"
export * from "./MasterPayments.vue?vue&type=script&lang=js"

import "./MasterPayments.vue?vue&type=style&index=0&id=6a645ddd&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a645ddd"]])

export default __exports__